import React from "react";
import { gql, useQuery } from "@apollo/client";
import { MapContainer, TileLayer, CircleMarker, Tooltip, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./WorldMap.css";

const GET_INCIDENTS = gql`query { globalIncidents(limit: 500) { id lat lng model detectedAt siteId } }`;
const GET_SITES = gql`query { siteStatuses { id name lat lng nodesTotal nodesOnline eventsToday } }`;

export default function WorldMap() {
  const inc = useQuery(GET_INCIDENTS, { pollInterval: 15000 });
  const sit = useQuery(GET_SITES, { pollInterval: 15000 });
  const incidents = (inc.data?.globalIncidents || []).filter((i: any) => i.lat != null && i.lng != null);
  const sites = (sit.data?.siteStatuses || []).filter((s: any) => s.lat != null && s.lng != null);

  let center: [number, number] = [30, 10];
  let zoom = 2;
  if (incidents.length) { center = [incidents[0].lat, incidents[0].lng]; zoom = 6; }
  else if (sites.length) { center = [sites[0].lat, sites[0].lng]; zoom = 6; }

  return (
    <div className="page-container">
      <div className="page-header"><h2>🌍 Global Incident Map</h2></div>
      <div className="wm-summary">
        <span><b>{incidents.length}</b> recent incidents</span>
        <span><b>{sites.length}</b> located objects</span>
      </div>
      <div className="wm-map">
        <MapContainer center={center} zoom={zoom} style={{ width: "100%", height: "100%" }} attributionControl={false} worldCopyJump>
          <TileLayer url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}" maxZoom={20} />
          {incidents.map((i: any) => (
            <CircleMarker key={i.id} center={[i.lat, i.lng]} radius={4}
              pathOptions={{ color: "#ef5350", fillColor: "#ef5350", fillOpacity: 0.55, weight: 1 }}>
              <Tooltip>{(i.model || "Target")} · {new Date(i.detectedAt).toLocaleString()}</Tooltip>
            </CircleMarker>
          ))}
          {sites.map((s: any) => (
            <CircleMarker key={s.id} center={[s.lat, s.lng]} radius={9}
              pathOptions={{ color: "#4fc3f7", fillColor: "#1e88e5", fillOpacity: 0.5, weight: 2 }}>
              <Popup>
                <b>{s.name}</b><br />
                Nodes {s.nodesOnline}/{s.nodesTotal}<br />
                Events today {s.eventsToday}
              </Popup>
            </CircleMarker>
          ))}
        </MapContainer>
      </div>
    </div>
  );
}
